import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';
import { isSystemAdmin } from '../utils/permissions';

const AdministrationAccessContext = createContext(null);

export const useAdministrationAccess = () => {
  const context = useContext(AdministrationAccessContext);
  if (!context) {
    throw new Error('useAdministrationAccess debe usarse dentro de AdministrationAccessProvider');
  }
  return context;
};

/** @deprecated Unlock tokens removed; kept for API compatibility. */
export const getAdminUnlockToken = () => '';

/** @deprecated Unlock tokens removed; kept for API compatibility. */
export const clearAdminUnlockToken = () => {};

export const AdministrationAccessProvider = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const allowed = Boolean(isAuthenticated && isSystemAdmin(user));

  const lock = useCallback(() => {}, []);
  const refreshStatus = useCallback(async () => allowed, [allowed]);
  const unlock = useCallback(async () => {
    throw new Error(
      'El desbloqueo por contraseña fue eliminado. Solo el rol Administrador puede acceder.'
    );
  }, []);

  const value = useMemo(
    () => ({
      unlocked: allowed,
      checking: false,
      unlockToken: '',
      unlock,
      lock,
      refreshStatus,
      adminBypass: allowed,
    }),
    [allowed, unlock, lock, refreshStatus]
  );

  return (
    <AdministrationAccessContext.Provider value={value}>
      {children}
    </AdministrationAccessContext.Provider>
  );
};
